import * as Yup from 'yup';
import ValidationErrors from '../../../../constants/ValidationErrors';

export const getInformationValidationSchema = (language: string) => {
  return Yup.object({
    email: Yup.string().required(ValidationErrors[language].REQUIRED)
      .email(ValidationErrors[language].EMAIL),
    prefix1: Yup.string(),
    prefix2: Yup.string().oneOf([Yup.ref('prefix1')], ValidationErrors[language].PREFIX_MATCH),
    msisdn1: Yup.string()
      .required(ValidationErrors[language].REQUIRED)
      .matches(/^\d+$/, ValidationErrors[language].JUST_NUMBERS)
      .min(6, ValidationErrors[language].MSIDN_MIN.replace('%', '6'))
      .max(7, ValidationErrors[language].MSIDN_MAX.replace('%', '7')),
    msisdn2: Yup.string()
      .required(ValidationErrors[language].REQUIRED)
      .matches(/^\d+$/, ValidationErrors[language].JUST_NUMBERS)
      .min(6, ValidationErrors[language].MSIDN_MIN.replace('%', '6'))
      .max(7, ValidationErrors[language].MSIDN_MAX.replace('%', '7'))
      .oneOf([Yup.ref('msisdn1')], ValidationErrors[language].MSISDN_MATCH),
    amount: Yup.string(),
    checked: Yup.boolean().oneOf([true], ValidationErrors[language].ACCEPT_CONDITIONS),
  });
};
